import { render, staticRenderFns } from "./doublecheck-card.vue?vue&type=template&id=e81c1322&"
import script from "./doublecheck-card.vue?vue&type=script&lang=js&"
export * from "./doublecheck-card.vue?vue&type=script&lang=js&"
import style0 from "./doublecheck-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports